import * as _ from "lodash";
import angular = require("angular");
import { AttributionRepo } from "@services/attribution.repo";
import { extractErrorMessage } from "@common/utils/errorUtils";
import {
  DialogData,
  PortfolioAttributionBenchmarkFM,
  PortfolioAttributionBenchmarkValues,
} from "@models/portfolioadmin/PortfolioAttributionBenchmarkDto ";
class BenchmarkAttributionEditController implements angular.IOnInit {
  public portfolioAttributionBenchmark: PortfolioAttributionBenchmarkValues;
  public dialogData: DialogData;

  public errorMessages: { [key: string]: string[] } = {};
  public originalPortfolioAttributionBenchmark: PortfolioAttributionBenchmarkValues;
  public isLoading: boolean = false;
  public isSaveButtonEnabled: boolean = true;

  public fromDate: Date = new Date();
  public attributionFromDate: Date = new Date();

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private attributionRepo: AttributionRepo,
    private notifyjs
  ) {}

  $onInit() {
    this.isLoading = true;
    this.portfolioAttributionBenchmark =
      this.dialogData.portfolioAttributionBenchmark;
    this.originalPortfolioAttributionBenchmark =
      this.portfolioAttributionBenchmark;
  }

  $onChanges(changes) {
    console.log();
  }

  public validateAmount(amount: number, property: string) {
    if (
      this.errorMessages[property] === undefined ||
      this.errorMessages[property] === null ||
      !this.errorMessages[property]
    ) {
      this.errorMessages[property] = [];
    } else {
      this.errorMessages[property].length = 0;
    }

    if (amount < -1 || amount > 1) {
      this.errorMessages[property].push(
        "Value must be a number between -1 and 1."
      );
      this.notifyjs("Value must be a number between -1 and 1.");
    }

    if (!/^\d+(\.\d{1,2})?$/.test(amount.toString())) {
      this.errorMessages[property].push(
        "Value can have a maximum of 2 decimal places."
      );
      this.notifyjs("Value can have a maximum of 2 decimal places.");
    }
  }

  public fromDateChanged() {
    this.attributionFromDate = this.fromDate;
  }

  public save() {
    this.isLoading = true;
    this.portfolioAttributionBenchmark.isUpdated = true;
    this.isSaveButtonEnabled = false;

    if (this.dialogData.portfolioAttributionBenchmark.isExisting) {
    }
    if (this.dialogData.addingANewBenchmarkEntry) {
      this.attributionRepo
        .updatePortfolioAttributionBenchmarks(
          this.dialogData.client,
          this.portfolioAttributionBenchmark
        )
        .then((res) => {
          this.notifyjs("Successfully added new benchmark", "success");
          this.$mdDialog.hide();
        })
        .catch((err) => {
          this.notifyjs(extractErrorMessage(err));
        })
        .finally(() => {
          this.isSaveButtonEnabled = true;
        });
    } else {
      var payload: PortfolioAttributionBenchmarkFM = this
        .portfolioAttributionBenchmark as unknown as PortfolioAttributionBenchmarkFM;
      payload.attributionDate = this.attributionFromDate;

      this.attributionRepo
        .addPortfolioAttributionBenchmarkFM(this.dialogData.client, payload)
        .then((res) => {
          this.notifyjs(
            "Successfully added new benchmark percentages",
            "success"
          );
          this.$mdDialog.hide();
        })
        .catch((err) => {
          this.notifyjs(`Could not add new benchmark percentages: ${extractErrorMessage(err)}`);
        })
        .finally(() => {
          this.isSaveButtonEnabled = true;
        });
    }
  }

  public cancel() {
    this.portfolioAttributionBenchmark =
      this.originalPortfolioAttributionBenchmark;
    this.$mdDialog.hide();
    this.isLoading = false;
  }
}

export const benchmarkAttributionEditDialog: angular.IComponentOptions = {
  template: require("./benchMarkAttributionEdit.dialog.html"),
  controller: BenchmarkAttributionEditController,
  bindings: {
    dialogData: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/benchmarkAttribution/benchMarkAttributionEditDialog/benchMarkAttributionEdit.dialog.ts